import React, { Component } from 'react';
import { getVideoImageUrl, getHash } from '../../../../../../api';
import './DetailVideo.css';
import { PATH, VIDEO_EVENT } from '../../../../../../constants';
import { TEXT } from '../../../../../../content';
import { features } from '../../../../../../utils/Features';

class DetailVideo extends Component {
  constructor(props) {
    super(props);

    this.videoCheckTick = null;
    this.videoReady = false; // note - check if ok to save value outside of state
    this.videoStartSeek = 0;

    this.videoFrameRef = React.createRef();

    this.playVideo = this.playVideo.bind(this);
    this.videoFrameLoaded = this.videoFrameLoaded.bind(this);
  }

  // -------------------------------------------------------
  // Lifecycle
  // -------------------------------------------------------

  componentWillUnmount() {
    clearTimeout(this.videoCheckTick);
  }

  // -----------------------------------------------------
  // Helpers
  // -----------------------------------------------------

  onVideoPlay() {
    const { onVideoUpdate } = this.props;
    onVideoUpdate(VIDEO_EVENT.PLAYING, true);
    // try seek on forst start
    if (!this.videoReady) {
      this.videoReady = true;
      if (this.videoStartSeek > 0) {
        this.seekVideo(false, this.videoStartSeek);
      }
    }
  }

  getVideoFrame() {
    // note - try / catch used in all references because of players unexpected behavior
    try {
      return this.videoFrameRef.current.contentWindow;
    } catch (e) {
      return null;
    }
  }

  getVideoElement() {
    try {
      return this.getVideoFrame().document.getElementById('video');
    } catch (e) {
      return null;
    }
  }

  getVideoPlayer() {
    try {
      return this.getVideoFrame().player;
    } catch (e) {
      return null;
    }
  }

  getVideoTime() {
    const video = this.getVideoElement();
    if (video) {
      return Math.round(video.currentTime * 1000);
    }
    return 0;
  }

  // -----------------------------------------------------
  // Content
  // -----------------------------------------------------

  getContent() {
    const { videoStarted } = this.props;
    if (videoStarted) {
      return this.contentVideo();
    }
    return this.contentInit();
  }

  contentInit() {
    const { detailId } = this.props;
    return (
      <button id="video-init-button" type="button" onClick={this.playVideo}>
        <img
          id="video-init-thumb"
          src={getVideoImageUrl(detailId)}
          alt={TEXT.VIDEO_THUMB}
        />
        <img
          id="video-init-play"
          src={`${PATH.IMG}ico/btn-play.png`}
          alt={TEXT.BTN_PLAY}
        />
      </button>
    );
  }

  contentVideo() {
    const { detailId } = this.props;
    return (
      <iframe
        title={TEXT.VIDEO}
        id="video-player"
        src={`${PATH.FRAME}?hash=${getHash()}&bonus=${detailId}&origin=noads`}
        ref={this.videoFrameRef}
        onLoad={this.videoFrameLoaded}
        allowFullScreen
      />
    );
  }

  // -----------------------------------------------------
  // Video
  // -----------------------------------------------------

  playVideo(initSeek) {
    const { videoStarted, onVideoUpdate } = this.props;
    this.videoStartSeek = initSeek || 0;
    if (videoStarted) {
      // just paused -> play
      const player = this.getVideoPlayer();
      if (player) {
        player.play();
      }
    } else {
      // first start
      onVideoUpdate(VIDEO_EVENT.STARTED, true);
    }
  }

  pauseVideo() {
    const player = this.getVideoPlayer();
    // note - not sure about this repeating condition - maybe think about better solution
    if (player) {
      player.pause();
    }
  }

  seekVideo(add, value) {
    if (this.videoReady) {
      const player = this.getVideoPlayer();
      const video = this.getVideoElement();
      if (player && video) {
        const { currentTime, duration } = video;
        const seekTime = add ? Math.round(currentTime * 1000) + value : value;
        const seekParsed = Math.max(
          0,
          Math.min(seekTime, Math.round(duration * 1000))
        );
        player.seek(seekParsed);
        // seek 'fix' (more like hack)
        if (features.firefox) {
          video.currentTime = Math.round(seekParsed / 1000 / 2) * 2;
        } else {
          video.currentTime = seekParsed / 1000;
        }
        player.pause();
      }
    }
  }

  videoFrameLoaded() {
    const { onVideoUpdate } = this.props;
    const video = this.getVideoElement();
    this.videoReady = false;

    if (video === null) {
      this.videoCheckTick = setTimeout(() => {
        this.videoFrameLoaded();
      }, 200);
    } else {
      if (!video.paused) {
        // fix if video already playing
        this.onVideoPlay();
      }
      video.onplay = () => {
        this.onVideoPlay();
      };
      video.onpause = () => {
        onVideoUpdate(VIDEO_EVENT.PLAYING, false);
      };
      video.onended = () => {
        onVideoUpdate(VIDEO_EVENT.STARTED, false);
      };
    }
  }

  // -----------------------------------------------------
  // Render
  // -----------------------------------------------------

  render() {
    return <div id="detail-video-wrap">{this.getContent()}</div>;
  }
}

export default DetailVideo;



// WEBPACK FOOTER //
// ./src/components/App/Okupace/Content/Detail/DetailVideo/DetailVideo.js